import React, { Component } from 'react'
import { config } from '../../config'
import moment from 'moment-timezone'

import { ScrollUpButton } from '../index'

import './footer.component.scss'

/**
 * Footer Component
 */
class Footer extends Component {

  /**
   * Render child component
   * @param children
   * @returns {function()}
   */
  getComponent = (children) => {
    if (!children || typeof children !== 'object') {
      return null
    }

    return () => {
      return (
        <div className='footer_component'>
          {children}
        </div>
      )
    }
  }

  /**
   * Render Footer
   * @returns {*}
   */
  render () {
    const { children } = this.props
    const Component = children && this.getComponent(children)
    const currentYear = moment().get('year')

    return (
      <div id='app-footer' className='footer'>
        <div className='footer_inner'>
          <ScrollUpButton />
          {Component ? <Component /> : null}
          <p>
            <span>&copy; Copyright Q4 Inc. {currentYear}. All rights reserved.</span>
            <span>Powered By Q4 Inc. {config.version}</span>
          </p>
        </div>
      </div>
    )
  }
}

export default Footer